import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "../../context/UserContext";
import Promotion from "./screens/Promotion";
import Platform from "./screens/Platform";
import About from "./screens/About";
import GetStarted from "./screens/GetStarted";
import FeaturesList from "./screens/FeaturesList";
import FAQ from "./screens/FAQ";
import Pricing from "../Pricing";

const HomeSections = () => {
  const { user } = useUser();
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      document.getElementById(decodeURIComponent(hash.slice(1)))?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [hash]);

  return (
    <>
      {!user && <Promotion />}
      <Platform />
      <FeaturesList />
      <Pricing />
      <About />
      <GetStarted />
      <FAQ />
    </>
  );
};

export default HomeSections;
